import 'jquery-ui/ui/widgets/autocomplete';
import FamilyPlanService from '../famil-plan.service';
import {FamilyPlanInfoDto, FamilyPlanMemberType} from '../family-plan.model';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { ManageSubDeleteDialogAction } from '../manage-sub-delete-dialog/manage-sub-delete-dialog.action';
import { masterAddressUpdateDialogAction } from '../master-address-update-dialog/master-address-update-dialog.action';
import { ITimeoutService } from 'angular';
import { OpenAboutDialogAction } from '../family-plan-about-dialog/family-plan-about-dialog.action';
import { FamilyPlanTypes } from '../../common/services/package/package.model';

/* @ngInject */
export default class familPlanMemberInfoController {
  public subInfo:FamilyPlanInfoDto;
  public selectedAddress:any;
  private addressChange: any;
  public addressUpdateText: string;
  private type: FamilyPlanTypes;
  constructor(
    private familyPlanService: FamilyPlanService,
    private actionDispatcher: ActionDispatcherService,
    private $translate,
    private $timeout: ITimeoutService,
    private $sce,
    private $state
  ) {

  }

  public $onInit() {
    this.familyPlanService.getFamilyPlanInfo(this.type).then(memberDto => {
      this.subInfo = memberDto;
      if(this.subInfo.subMembers[0].familyPlanAdressUpdate){
        this.$translate("familyPlan.memberAddressMessagebox", this.subInfo.subMembers[0]).then(value => {
          this.addressUpdateText = this.$sce.trustAsHtml(value);
        });
      }
    }).catch(e => {
      this.$state.go("myAccount");
    });
    angular.element(document).ready(() => {
      if(this.type == FamilyPlanTypes.FAMILY) {
        this.addressAutoComplete(); 
      }
    });
  }

  public onDiscard(){
    this.actionDispatcher.dispatch(new ManageSubDeleteDialogAction(this.type));
  }


 public fpInfoSavedInfos(){
  this.actionDispatcher.dispatch(new masterAddressUpdateDialogAction(this.selectedAddress, FamilyPlanMemberType.SUB));
 }

 public addressAutoComplete(){
  this.addressChange = angular.element('#address');
  var self = this;
  self.autoComplete(self, '');
  this.addressChange.bind('paste keyup', function (evnt)  {
    self.$timeout(() => {
      let addressinputval =  evnt.target.value;
      self.autoComplete(self, addressinputval) , 500
    });
  });
 };

  private autoComplete(self: this, addressinputval: any) {
    return $("#address").autocomplete({
      source: function (request, response) {
        self.familyPlanService.addressAutoComplete(addressinputval).then(result => {
          response(result);
        });
      },
      create: function () {
      },
      select: function (event, ui) {
        let adress = [];
        for (let i = 0; i < 16; i++) {
          adress.push(ui.item[i]);
        }

        self.selectedAddress = adress;
        $("#address").val(ui.item[0]);
        return false;

      }
    })
      .data("ui-autocomplete")._renderItem = function (ul, item) {
        return $("<li>")
          .append("<div class='crspointer'>" + item[0] + "</div>")
          .appendTo(ul);
      };
  }

  public onAbout(){
    this.actionDispatcher.dispatch(new OpenAboutDialogAction(this.type));
  }

  public isDuoPackage() {
    return this.type == FamilyPlanTypes.DUO;
  }
}



// WEBPACK FOOTER //
// ./src/app/family-plan/family-plan-member-info/family-plan-member-info.controller.ts